<template>
    <el-dialog :visible.sync="visible"
        :width="width"
        v-drag-dialog
        append-to-body
        :title="title"
        custom-class="confirm-dialog"
        :show-close="true"
        :top="top"
        v-on="$listeners"
        @closed="$emit('closed')"
        :close-on-click-modal="false">
        <slot/>
        <template slot="footer">
            <slot name="footer"/>
            <el-button v-if="showCancel" @click="cancel" :loading="loading">{{cancelText}}</el-button>
            <submit-btn ref="submitBtn" v-if="submitApi && showConfirm" :api="submitApi" type="primary" :model="model" :before-submit="beforeSubmit" @success="res => $emit('success', res)" @error="$emit('error')">{{confirmText}}</submit-btn>
            <el-button v-else-if="showConfirm" type="primary"  @click="confirm" :loading="loading">{{confirmText}}</el-button>
        </template>
    </el-dialog>
</template>

<script>
import {on, off} from '../utils/dom'
import SubmitBtn from './submit-btn'
export default {
  name: 'v-dialog',
  components: {
    SubmitBtn
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: false,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    width: {},
    showCancel: {
      type: Boolean,
      default: true
    },
    showConfirm: {
      type: Boolean,
      default: true
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    confirmText: {
      type: String,
      default: '确定'
    },
    top: {
      type: String,
      default: '15vh'
    },
    submitApi: {
      type: String,
      default: ''
    },
    beforeSubmit: {
      type: Function,
      default () {
        return () => {
           return new Promise(resolve => {
            resolve(true)
          })
        }
      }
    },
    model: {
      type: [Object, Function]
    },
    whiteList: {
      type: Array,
      default () {
        return [
          'TEXTAREA'
        ]
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (value) {
        this.visible = value
      }
    },
    visible (value) {
      this.$emit('input', value)
      if (value) {
        on(window, 'keydown', this.onKeyDown)
      } else {
        off(window, 'keydown', this.onKeyDown)
      }
    }
  },
  data () {
    return {
      visible: false
    }
  },
  methods: {
    confirm () {
      if (this.showConfirm) {
        this.$emit('confirm')
      }
    },
    cancel () {
      this.visible = false
      this.$emit('cancel')
    },
    onKeyDown (e) {
      let target = e.target
      // 过滤特殊节点
      if (this.whiteList.indexOf(target.nodeName) !== -1) return
      if (e.keyCode === 13) {
        e.stopPropagation()
        if (this.submitApi) this.$refs.submitBtn.submit()
        else this.confirm()
      }
    }
  },
  beforeDestroy () {
    off(window, 'keydown', this.onKeyDown)
  }
}
</script>

<style lang="less">
@import '../color.less';
.confirm-dialog {
    .el-dialog__header {
      border-bottom: 1px solid #DCDFE6;
      background: @primary;
      .el-dialog__title, .el-dialog__close {
        color: #fff!important;
      }
      .el-dialog__headerbtn {
        height: 24px;
        background: rgba(0, 0, 0, 0.2);
        border-radius: 50%;
        width: 24px;
        &:hover {
          background: rgba(0, 0, 0, 0.4);
        }
      }
      .el-dialog__close {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .el-dialog__footer {
      border-top: 1px solid #DCDFE6;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/framework/widgets/confirm-dialog.vue